<template>
  <div>
    <!--      Conform Box-->
    <vue-confirm-dialog></vue-confirm-dialog>

<!--    Top bar -->
    <top-bar :report_id="0"/>

    <div class="modal fade vorlage" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lgx">
        <div class="modal-content">
          <div class="modal-body upload-body">
            <div class="upload-full mb-4">
              <div class="float-left upload-lf">Vorlage Bearbeiten</div>
              <div class="float-right"> <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              </div>
            </div>
            <p class="font12 mb-1">Bezeichnung</p>
            <div class="font-10 mb-4 vrname col-md-7">Geben Sie dem neuen Bericht einen Namen</div>

            <div class="dokubtns">
              <button type="button" class="btn btn-gray mb-5">Vorlage löschen</button>
              <div class="btninner clearfix">
                <button type="button" class="btn btn-red">Abbrechen</button>
                <button type="button" class="btn btn-blue">Speichem</button>
              </div>
            </div>
            <div id="preview" class="d-flex align-content-start flex-wrap"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- Add all page content inside this div if you want the side nav to push page content to the right (not used if you only want the sidenav to sit on top of the page -->
    <div id="main" class="skybackground pt-0 pb-0">
      <div class="row">

        <div class="col col-md-6 screen-height pr-1">
          <div class="docuvtabs">
            <!--           Tabs Links Component -->
            <construction-diary-side-tabs-links/>

            <div class="tab-content h-auto mb-3 pb-1">
              <div class="clearfix"></div>
              <!-- Construction Photos Tab-->
              <construction-photos-tab :report="report"/>

              <!--  Construction Text Module Tab-->
              <construction-text-module-tab/>

              <div class="tab-pane" id="dtab5" role="tabpanel">
                <div class="mb-3">
                  <h3>Einstellungen</h3>
                  <div>
                    <div class="form-row mb-3 border-bottom pb-2">
                      <label class="col-sm-4 pt-2">
                        <strong>Bericht sperren</strong>
                        <br>
                        <small> ( Bei Anderugen wird eine Revision angelegt ) </small>
                      </label>
                      <div class="col-sm-6">
                        <div class="switch new mt-2">
                          <label class="w-100 ml-3">
<!--                            <input type="checkbox" v-model="project.constructionreport">-->
                            <input type="checkbox" v-model="reportLocked"
                                   :true-value="1"
                                   :false-value="0" />
                            <span class="lever mr-0"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <label class="col-sm-12 pl-0">
                      <strong>Kopfzeile</strong>
                    </label>
                    <div class="form-row mb-1 pl-4">
                      <label class="col-sm-3 pt-2">
                        <strong>Projektnummer</strong>
                      </label>
                      <div class="col-sm-6">
                        <div class="switch new">
                          <label>
                            <input type="checkbox" v-model="show_projectnumber">
                            <span class="lever mr-0"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-row mb-1 pl-4">
                      <label class="col-sm-3">
                        <strong>Bauherr</strong>
                      </label>
                      <div class="col-sm-6">
                        <div class="switch new">
                          <label>
                            <input type="checkbox" v-model="show_constructor">
                            <span class="lever mr-0"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="form-row mb-1 pl-4">
                      <label class="col-sm-3">
                        <strong>Ersteller</strong>
                      </label>
                      <div class="col-sm-6">
                        <div class="switch new">
                          <label>
                            <input type="checkbox" v-model="show_creator">
                            <span class="lever mr-0"></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <!--                 Second part started here-->
                    <label class="col-sm-12 pl-0">
                      <strong>Fußzeile</strong>
                    </label>
                    <div class="form-row mb-1 pl-4">
                      <label class="col-sm-3 pt-2">
                        <strong>Erstellt durch</strong>
                      </label>
                      <div class="col-sm-8">
                        <div class="switch new d-inline-block align-content-start">
                          <label>
                            <input type="checkbox" v-model="left_footer">
                            <span class="lever mr-0"></span>
                          </label>
                        </div>
                        <div class="mb2 d-inline-block ml-3">
                          <div class="check-sides-box border  rounded">
                            <div class="left-box border-right d-inline-block" :class="{active: left_footer_creator}" @click="footerLeftCreatorClick">Ersteller anzeigen</div>
                            <div class="right-box d-inline-block" :class="{active: left_footer_text}" @click="footerLeftTextClick">Eigener Text</div>
                          </div>
                        </div>
                        <div class="mb-2 d-inline-block ml-3">
                          <input type="text" class="form-control-sm form-control" v-model="left_footer_text_input">
                        </div>

                      </div>
                    </div>
                    <div class="form-row mb-1 pl-4">
                      <label class="col-sm-3">
                        <strong>Geprüft AN</strong>
                      </label>
                      <div class="col-sm-6">
                        <div class="switch new d-inline-block">
                          <label>
                            <input type="checkbox" v-model="center_footer">
                            <span class="lever mr-0"></span>
                          </label>
                        </div>
                        <div class="mb-2 d-inline-block ml-3">
                          <input type="text" class="form-control-sm form-control" v-model="center_footer_text">
                        </div>
                      </div>
                    </div>
                    <div class="form-row mb-1 pl-4">
                      <label class="col-sm-3">
                        <strong>Gesehen AG</strong>
                      </label>
                      <div class="col-sm-6">
                        <div class="switch new d-inline-block">
                          <label>
                            <input type="checkbox" v-model="right_footer">
                            <span class="lever mr-0"></span>
                          </label>
                        </div>
                        <div class="mb-2 d-inline-block ml-3">
                          <input type="text" class="form-control-sm form-control" v-model="right_footer_text">
                        </div>
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="col col-md-6 screen-height pr-1 pl-0 border-left">
          <div id="photodoku">
            <div class="innerdoc pr-2 pl-2">
              <div class="col-md-12 mb-3">
                <div class="row">
                  <div class="col-md-6">
                    <span class="float-left">
                      <img :src="logoOne" class="mb-2 img-fluid logo-images-in-docs" alt="img">
                    </span>
                  </div>
                  <div class="col-md-6">
                    <span class="float-right">
                      <img :src="logoTwo" class="mb-2 img-fluid logo-images-in-docs" alt="img">
                    </span>
                  </div>
                </div>
              </div>
              <h2 class="text-center">
                <template v-if="report.constructionreport.reporttype == 'W'">
                  WOCHENBERICHT
                </template>
                <template v-else>
                  TAGESBERICHT
                </template>
              </h2>
              <div class="clearfix"></div>
              <div class="pb-4 pt-2 pl-2">
                <div class="row project-info">
                  <div class="col-md-3 font mt-1"><strong>Bericht-Nr : </strong></div>
                  <div class="col-md-9 font mt-1">
                    <strong>{{report.constructionreport.runid}} / Rev : {{report.constructionreport.revision}}  </strong>
                    <strong class="pl-2">
                      <span v-show="report.constructionreport.reporttype==='W'">
                      {{ formatDate(report.constructionreport.reportstartdate) }} - </span>
                      {{ formatDate(report.constructionreport.crdate) }}
                    </strong>
                  </div>
                  <div class="col-md-3 font">Projektname : </div>
                  <div class="col-md-8 font"> {{project.name}} </div>
                  <div class="col-md-3 font pr-0" v-if="report.constructionreport.reportparams.show_projectnumber">Projektnummer : </div>
                  <div class="col-md-2 font" v-if="report.constructionreport.reportparams.show_projectnumber"> {{ project.number }}</div>
                  <div class="col-md-6 font" v-if="report.constructionreport.reportparams.show_constructor">Bauherr : {{ project.constructor }} </div>
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col-md-3 font pr-0" v-if="report.constructionreport.reportparams.show_creator">Berichtersteller : </div>
                      <div class="col-md-9 font" v-if="report.constructionreport.reportparams.show_creator"> {{ currentuser.firstname }} {{ currentuser.lastname }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="wetterinfo pb-3 p-1 pl-2 border">
                <div class="switch float-right mr-2">
                  <span class="lever mr-0">Erledigt</span>
                  <label class="pl-2 mb-0" for="weather-switch-one">
                    <input type="checkbox" id="weather-switch-one" v-model="report.weather.done" :true-value="1" :false-value="0" >
                    <span class="lever mr-0"></span>
                  </label>
                </div>
                <h5 class="mb-1 mt-2 font"><b>Wetter</b></h5>
                <div class="weticons mb-2">
                  <ul>
                    <li>
                      <input type="checkbox"  :true-value="1"  :false-value="0" v-model="report.weather.weather_sunny" id="myCheckbox1"/>
                      <label for="myCheckbox1">
                        <img src="@/assets/images/weather_sunny.png" alt="img">
                      </label>
                    </li>
                    <li>
                      <input type="checkbox" :true-value="1"  :false-value="0" v-model="report.weather.weather_covered" id="myCheckbox2"/>
                      <label for="myCheckbox2">
                        <img src="@/assets/images/weather_sunnytocloudy.png" alt="img">
                      </label>
                    </li>
                    <li>
                      <input type="checkbox" :true-value="1"  :false-value="0" v-model="report.weather.weather_cloudy" id="myCheckbox3"/>
                      <label for="myCheckbox3">
                        <img src="@/assets/images/weather_cloudy.png" alt="img">
                      </label>
                    </li>
                    <li>
                      <input :true-value="1"  :false-value="0" v-model="report.weather.weather_rain" type="checkbox" id="myCheckbox4" />
                      <label for="myCheckbox4">
                        <img src="@/assets/images/weather_rain.png" alt="img">
                      </label>
                    </li>
                    <li>
                      <input :true-value="1"  :false-value="0" v-model="report.weather.weather_storm" type="checkbox" id="myCheckbox5" />
                      <label for="myCheckbox5">
                        <img src="@/assets/images/weather_storm.png" alt="img">
                      </label>
                    </li>
                    <li>
                      <input :true-value="1"  :false-value="0" v-model="report.weather.weather_snow" type="checkbox" id="myCheckbox6"/>
                      <label for="myCheckbox6">
                        <img src="@/assets/images/weather_snow.png" alt="img">
                      </label>
                    </li>
                    <li>
                      <input type="checkbox" :true-value="1"  :false-value="0" v-model="report.weather.weather_thunderstorm" id="myCheckbox7"/>
                      <label for="myCheckbox7">
                        <img src="@/assets/images/weather_thunder.png" alt="strom">
                      </label>
                    </li>
                  </ul>
                </div>
                <div class="wetinfo">
                  <div class="form-row">
                    <div class="col-md-3">Temperatur Min
                      <input  v-model="report.weather.temperature_min" class="border form-control" type="number"/>
                    </div>
                    <div class="col-md-3">Temperatur Max
                      <input v-model="report.weather.temperature_max" class="border form-control" type="number"/>
                    </div>
                    <div class="col-md-3">Windstärke
                      <input v-model="report.weather.windspeed" class="border form-control" type="number"/>
                    </div>
                    <div class="col-md-3">Hydro
                      <input v-model="report.weather.humidity" class="border form-control" type="number"/>
                    </div>
                  </div>
                  <p class="mt-3 mb-2">Sonstige Wetterbemerkungen : </p>
                  <input class="form-control text-left" type="text" v-model="report.weather.misc">
                </div>
              </div>

                <div class="personalinfo mb-3 pt-3">

                  <h4 class="float-left"> <b>Personal </b> </h4>
                  <div class="switch float-right mr-2">
                    <span class="lever mr-0">Erledigt</span>
                    <label class="pl-2 mb-0" for="personal-switch">
                      <input type="checkbox" id="personal-switch" v-model="report.staff.done" :true-value="1" :false-value="0">
                      <span class="lever mr-0"></span>
                    </label>
                  </div>
                  <div class="table-responsive border-top pt-3 mt-1" v-for="(shift , shiftIndex) in report.staff.shifts">
                    <div class=" m-0 row">
                      <div class="col-md-3 pl-0">
                        <h4> {{shift.crshiftname}} </h4>
                      </div>
                      <div class="col-md-9 pl-0">
                        <label class="font16"> Start :</label>
                            <vue-timepicker v-model="shift.start"/>
                          <label class="font16"> End :</label>
                            <vue-timepicker v-model="shift.end"/>
                      </div>
                    </div>
                    <table class="table tblinfo tblprsnl">
                      <tr>
                        <th><span class="pl-2">Firma</span>  </th>
                        <th v-for="shiftType in shift.stafftypes">
                            {{shiftType.stafftypename}}
                        </th>
                      </tr>
                      <tr v-for="(shiftValues, index) in shift.stafftypes[0].workingvalues" class="shifts-trs">
                        <td>
                          <span class="w-100" style="min-width: 9rem; max-width: 16rem">
                            <input type="text"  v-model="shiftValues.companyname" class="text-left w-100">
                          </span>
                        </td>
                        <td v-for="(type, i) in shift.stafftypes">
                          <span class="border">
                            <input type="text" v-model="type.workingvalues[index].workingvalue">
                          </span>
                          <img v-if="i === (shift.stafftypes.length - 1)" @click="removeShift(shift , index)" src="@/assets/images/delete_icon.png" alt="remove" width="24" class="delete-icon">
                        </td>
                      </tr>
                      <tr>
                        <td :colspan="shift.stafftypes.length">
                          <button type="button" class="btn btn-light" @click="addNewShift(shift)">
                          <i class="fa fa-plus-circle" aria-hidden="true"></i>&nbsp;Firma&nbsp;hinzufügen
                          </button>
                        </td>
                        <td></td>
                      </tr>
                    </table>
                  </div>
                </div>

              <div class="pt-3  pb-4 mb-3 border-top mt-3 col-md-12" v-for="(group,index) in report.groups">
                <h5 class="mb-1 float-left"><strong>{{group.crgroupname}}</strong></h5>
                <div class="switch float-right mr-2">
                  <span class="lever mr-0">Erledigt</span>
                  <label class="pl-2 mb-0" :for="`group-switch${index}`">
                    <input type="checkbox" :id="`group-switch${index}`" v-model="group.done" :true-value="1" :false-value="0">
                    <span class="lever mr-0"></span>
                  </label>
                </div>
                <div class="clearfix"></div>
                <div v-for="val in group.groupvalues">
                  <div class="form-group position-relative">
                    <button @click="saveText(val)" type="button" class="btn bg-blue btn-blue position-fixed btn-save-text" :style="{top: `${top}px`, left: `${left}px`}" v-show="activeFieldIndex === val.crgroupfieldid">
                      Textbaustein speichern
                    </button>
                    <input  class="mt-2 text-dark form-control mb-2" readonly :value="val.crgroupfieldname"/>
                  </div>
                  <div class="col-md-12 p-0 form-group">
                    <textarea class="form-control" @mousemove="setBtnPosition" @click="setBtnText" @keyup="setBtnText" @select="showSaveBtn(val.crgroupfieldid)"  @focusin="setActiveTextarea(val)" v-model="val.crgroupfieldvalue" rows="5"></textarea>
                  </div>
                </div>
              </div>

<!--              Photos part starts here -->
              <div class="col-md-12 simple-photos section-images" v-if="selectedPhotos && selectedPhotos.length > 0">
                <h4 class="font-weight-bold text-secondary mb-3"> Angefügte Fotos </h4>
                <div class="row" v-for="photo in selectedPhotos" :key="photo.pdphotoid">
                  <div class="col-md-5 mb-3 img-fluid">
                    <div data-aspect-ratio="4:3">
                      <div class="rounded rounded-lg pr-3" :style="{'background-image': 'url(\'' + getImagePath(photo.pdphotoid) + '\')'}"></div>
                      <div class="simple-photo-option mw-100 photo mb-0">
                        <ul class="text-center">
                          <li class="pl-2">Nr.{{photo.runid}}</li>
                          <li>|</li>
                          <li>{{photo.photodate | setDate}}  </li>
                          <li>|</li>
                          <li class="pr-2">{{photo.photodate | setTime}} Uhr</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-7 form-group mb-1">
                    <label class="font-weight-bold text-secondary">Beschreibung</label>
                    <textarea class="form-control" v-model="photo.descriptionextend" rows="7"></textarea>
                  </div>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="row">
                  <div class="col-sm-4">
                    <div style="width:100%; height:45px; border:1px solid #ced4da; padding: 0px 4px;" v-if="left_footer !== false">
                        <small style="padding:0; margin:0;">Erstellt durch:</small>
                        <p>{{left_footer_report_text}}</p>

                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div style="width:100%; height:45px; border:1px solid #ced4da; padding: 0px 4px;" v-if="center_footer !== false">
                        <small style="padding:0; margin:0;">geprüft AN:</small>
                        <p v-if="center_footer !== false">{{center_footer_text}}</p>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div style="width:100%; height:45px; border:1px solid #ced4da; padding: 0px 4px;" v-if="right_footer !== false">
                        <small style="padding:0; margin:0;">gesehen AG:</small>
                        <p v-if="right_footer !== false">{{right_footer_text}}</p>
                    </div>
                  </div>

                </div>
              </div>

              <p class="text-center border-top pt-3 pb-5 mt-1 mx-3">
                <span class="float-left">{{ report.constructionreport.runid }} / Rev: {{report.constructionreport.revision}}  &nbsp; &nbsp; &nbsp;{{ formatDate(report.constructionreport.crdate)  }}</span>
                <span class="float-right">projectdocu.com</span>
              </p>
            </div>
          </div>


          <div class="doku-btns-sticky pt-1">
            <span class="btninner">
              <button  type="button" class="btn btn-danger" @click="$router.push({name: 'constructionDocs',params:{ id: $route.params.id }})">
                Abbrechen
              </button>
              <button type="button" @click="updateConstructionReport" class="btn bg-blue btn-blue">
                Bericht aktualisieren
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ConstructionDiarySideTabsLinks from './SideBar/ConstructionDiarySideTabsLinks'
import WeatherTab from './SideBar/WeatherTab'
import ConstructionEquipmentTab from './SideBar/ConstructionEquipmentTab'
import ConstructionLayoutsTab from './SideBar/ConstructionLayoutsTab'
import ConstructionPhotosTab from './SideBar/ConstructionPhotosTab'
import ConstructionStaffTab from './SideBar/ConstructionStaffTab'
import ConstructionTextModuleTab from './SideBar/ConstructionTextModuleTab'
import ConstructionTextTab from './SideBar/ConstructionTextTab'
import TopBar from './ConstructionDiaryTopBar'
import VueTimepicker from 'vue2-timepicker'
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'
import {mapState} from 'vuex'
import axios from '../../../utils/axiosinstance'
// import axios from 'axios'
import {formatDate, formatTimeUhr} from '../../common'
export default {
  data () {
    return {
      top: 10,
      left: 10,
     activeFieldIndex: null
    }
  },
  filters: {
    setDate: (date) => formatDate(date),
    setTime: (date) => formatTimeUhr(date)
  },
  components: {
    TopBar,
    ConstructionDiarySideTabsLinks,
    WeatherTab,
    ConstructionTextModuleTab,
    ConstructionTextTab,
    ConstructionPhotosTab,
    ConstructionStaffTab,
    ConstructionLayoutsTab,
    ConstructionEquipmentTab,
    VueTimepicker
  },

  created () {
    if (this.$route.params.reportId && this.$route.params.reportId !== '0'){
      this.$store.dispatch("getConstructionReportById",{id: this.$route.params.reportId,isEdit: true})
    }

    if (this.logoOne === '' || !this.logoTwo){
      this.$store.dispatch("getProjectDetails",this.$route.params.id)
    }
    this.$store.commit('setActiveTextareaId' , null)
  },

  computed: {
    ...mapState({
      report: state => state.constructionDiary.reportDetailsCopy,
      attached_photos: state => state.constructionDiary.reportDetailsCopy.constructionreport.reportparams.attachedPhotos || [],
      selectedReport: state => state.constructionDiary.selectedReport,
      project: state => state.appSettings.project,
      logoOne: state => state.appSettings.logoOne,
      logoTwo: state => state.appSettings.logoTwo,
      selectedPhotos : state => state.constructionDiary.selected_report_photos,
      projectImg: state => state.appSettings.projectImage
    }),
    show_projectnumber: {
      get() {
          return this.report.constructionreport.reportparams.show_projectnumber || false
      },
      set(newValue) {
          this.report.constructionreport.reportparams.show_projectnumber = newValue
      }
    },
    reportLocked: {
      get() {
          return this.report.constructionreport.locked ? 1 : 0
      },
      set(newValue) {
          this.report.constructionreport.locked = newValue ? 1 : 0
      }
    },
    show_constructor: {
      get() {
          return this.report.constructionreport.reportparams.show_constructor || false
      },
      set(newValue) {
          this.report.constructionreport.reportparams.show_constructor = newValue
      }
    },
    show_creator: {
      get() {
          return this.report.constructionreport.reportparams.show_creator || false
      },
      set(newValue) {
          this.report.constructionreport.reportparams.show_creator = newValue
      }
    },
    left_footer_report_text: {
      get() {
        if(this.report.constructionreport.reportparams.left_footer == '%currentuser%') {
          return this.currentuser.firstname + ' ' + this.currentuser.lastname
        }
        if(this.report.constructionreport.reportparams.left_footer != false) {
          if(typeof this.report.constructionreport.reportparams.left_footer == "boolean" ) {
            return ''
          }
          return this.report.constructionreport.reportparams.left_footer
        }
        return ''
      },
      set() {

      }
    },
    left_footer: {
      get() {
        if(this.report.constructionreport.reportparams.left_footer == '%currentuser%') {
          return '%currentuser%'
        }
        if(this.report.constructionreport.reportparams.left_footer != false) {
          return true
        }
        return false
      },
      set(newValue) {
        this.report.constructionreport.reportparams.left_footer = newValue
      }
    },

    left_footer_creator() {
      if(this.report.constructionreport.reportparams.left_footer == '%currentuser%') {
        return true
      }
      return false
    },
    left_footer_text() {
      if(this.report.constructionreport.reportparams.left_footer != true && this.report.constructionreport.reportparams.left_footer != false) {
        if(this.report.constructionreport.reportparams.left_footer == '%currentuser%') {
          return false
        }
        return true
      }
      return false
    },
    left_footer_text_input: {
      get() {
        if(this.report.constructionreport.reportparams.left_footer != true && this.report.constructionreport.reportparams.left_footer != false) {
          if(this.report.constructionreport.reportparams.left_footer != '%currentuser%') {
            return this.report.constructionreport.reportparams.left_footer
          }
        }
        return ''
      },
      set(newValue) {
        this.report.constructionreport.reportparams.left_footer = newValue + ''
      }
    },





    center_footer: {
      get() {
        if(this.report.constructionreport.reportparams.center_footer != false) {
          return true
        }
        return false
      },
      set(newValue) {
        this.report.constructionreport.reportparams.center_footer = newValue
      }
    },
    center_footer_text: {
      get() {
        if(typeof this.report.constructionreport.reportparams.center_footer === "boolean") {
          return '';
        }
        return this.report.constructionreport.reportparams.center_footer
      },
      set(newValue) {
        this.report.constructionreport.reportparams.center_footer = newValue
      }
    },
    right_footer: {
      get() {
        return this.report.constructionreport.reportparams.right_footer != false;
      },
      set(newValue) {
        this.report.constructionreport.reportparams.right_footer = newValue
      }
    },
    right_footer_text: {
      get() {
        if(typeof this.report.constructionreport.reportparams.right_footer === "boolean") {
          return '';
        }
        return this.report.constructionreport.reportparams.right_footer
      },
      set(newValue) {
        this.report.constructionreport.reportparams.right_footer = newValue
      }
    },
  },
  methods: {
    getImagePath(photo_id) {
      const project_id = this.$route.params.id
      return `${process.env.VUE_APP_GET_METHOD_URL}img&projectid=${project_id}&id=${photo_id}&token=${localStorage.sessiontoken}`
    },
    footerLeftCreatorClick() {
      this.report.constructionreport.reportparams.left_footer = '%currentuser%'
    },
    footerLeftTextClick() {
      this.report.constructionreport.reportparams.left_footer = ''
    },
    setBtnPosition(e){
      if (this.activeFieldIndex === null){
        this.left = e.clientX - 40;
        this.top = e.clientY - 55;
      }
    },
    setBtnText(e){
      const _this = this;
      setTimeout(function (){
        const selection = window.getSelection();
        _this.activeFieldIndex = (selection && selection.type === 'Range') ? _this.activeFieldIndex : null;
        if (_this.activeFieldIndex !== null){
          _this.left = e.clientX - 40;
          _this.top = e.clientY - 55;
        }
      },210)
    },
    showSaveBtn(index){
      this.activeFieldIndex = index
    },
    async saveText(val){
      const selection = window.getSelection();
      const text = (selection && selection.type === 'Range') ? selection.toString() :  val.crgroupfieldvalue
      const payload = { project_id: this.$route.params.id, text_id: 0, text ,is_delete: 0}
      await this.$store.dispatch('updateOrCreateText',payload);
      this.activeFieldIndex = null
    },
  formatDate: (date) => formatDate(date),

   async setActiveTextarea (value) {
     await this.$store.commit('setActiveTextareaId' , value)
   },

   async setInactiveTextarea(){
     // await this.$store.commit('setActiveTextareaId' , null)
   },

    /**Update Construction Report Method
     *
     * @returns {Promise<void>}
     */
   async updateConstructionReport(){
     this.$store.commit('loading',true)
     let cons_report = this.report.constructionreport;
     cons_report.reportparams.attached_photos = this.selectedPhotos.map(im => {
       return { pdphotoid: im.pdphotoid, descriptionextend: im.descriptionextend }
     });
     if(cons_report.locked) {
       // Overwrite pduserid
       // overwrite pdusername
       cons_report.newpduserid = this.currentuser.pduserid
       cons_report.newcreator = this.currentuser.firstname + ' ' + this.currentuser.lastname
     }
     const group = this.report.groups;
     const weather = this.report.weather;
     const staff = this.report.staff;


      console.log('Updatereportdata', cons_report);

      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "updateConstructionReport",
          "parameters": [cons_report, weather, group, staff],
          "serviceName": "ProjectdocuService"
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('jwt'),
          }
        }).then(res => {
            if (res.status === 200 || res.statusText === 'OK'){
              this.$toast.success('Bautagesbericht aktualisiert')
              this.$router.push({name: 'ConstructionReportPreview',params:{ id: this.$route.params.id, reportId: res.data.constructionreport.constructionreportid }})
            }
      }).catch(error=> {
        console.log(error)
        this.$toast.success('Oops Something Went Wrong ....!')
      })
      this.$store.commit('loading',false)
    },


    addNewShift(shift){
     shift.stafftypes.forEach(item => {
       let workingValue = {
         companyname: "Firma",
         workingvalue: "0",
         _explicitType: "com\\projectdocu\\CRWorkingValueVO",
       }
       item.workingvalues.push(workingValue)
     })
    },

    removeShift(shift , index){
      this.$confirm({
        message: "Firma löschen?",
        button: {
          no: 'Abbrechen',
          yes: 'Ja'
        }, callback: confirm => {
          if (confirm) {
            shift.stafftypes.forEach(item => {
              item.workingvalues.splice(index , 1)
            })
          }
        }
      })
    }
  }
}
</script>
<style>
.weticons ul{
  list-style-type: none;
}
.project-info .font{
  font-size: 1.06rem !important;
  padding-top: 4px;
}
.weticons ul li{
  display: inline-block;
}

.weticons input[type="checkbox"][id^="myCheckbox"] {
  display: none;
}

.weticons label {
  border: 1px solid #fff;
  padding: 5px;
  display: block;
  position: relative;
  margin: 3px;
  cursor: pointer;
}

.weticons label:before {
  background-color: white;
  color: white;
  content: " ";
  display: block;
  border-radius: 50%;
  position: absolute;
  top: -7px;
  left: -5px;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 21px;
  transition-duration: 0.4s;
  transform: scale(0);
}

.weticons label img {
  height: 35px;
  width: 35px;
  transition-duration: 0.2s;
  transform-origin: 50% 50%;
}

.weticons :checked + label {
  border-color: #ddd;
}

.weticons :checked + label:before {
  content: "\2713";
  background-color: #007bff;
  -webkit-transform: scale(1);
  transform: scale(1);
  z-index: 100;
}

.weticons :checked + label img {
  transform: scale(0.9);
  /* box-shadow: 0 0 5px #333; */
  z-index: -1;
}
.wetinfo input{
  height: 1.85rem;
  padding-left: 4px;
  font-size: 1.03rem;
  text-align: center;
}
.tblprsnl tr input{
  width: 2.81rem;
  text-align: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.font16{
  font-size: 1rem;
  padding-right: 4px;
  padding-left: 6px;
}
.doku-btns-sticky{
  bottom: 1px;
  z-index: 99998;
  position: fixed;
  padding-left: 17%;
  width: 100%;
  background: #ffffff7a;
  border-top: 1px solid grey;
}
.doku-btns-sticky button,.doku-btns-sticky a{
  font-size: 14px;
  font-weight: normal !important;
  padding: 6px 18px;
  line-height: inherit;
}
.delete-icon{
  position: absolute;
  margin-left: 15px;
  margin-top: 2px;
  visibility: hidden;
  cursor: pointer;
}
table .shifts-trs:hover td .delete-icon{
 visibility: visible;
}
.btn-save-text{
  font-size: 14px;
  font-weight: normal !important;
  padding: 5px 16px;
  line-height: inherit;
  z-index: 99;
}
.check-sides-box div{
  padding: 7px 10px;
  font-size: 12px;
  cursor: pointer;
}
.check-sides-box div.active{
  background: #3399FF;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/constructionDiary/components/EditConstructionReport.vue